<button
  [type]="type"
  [id]="inputId"
  class="btn"
  [ngClass]="styleClass"
  (click)="onButtonClick()"
  [disabled]="isDisabled"
  [attr.aria-label]="computedAriaLabel"
  [attr.aria-disabled]="isDisabled ? 'true' : 'false'"
  [attr.aria-busy]="internalSpin ? 'true' : 'false'"
>
  <ng-container *ngIf="internalSpin; else labelTemplate">
    <fa-icon [icon]="faSpinner" animation="spin" size="2x" aria-hidden="true"></fa-icon>
  </ng-container>
</button>

<ng-template #labelTemplate>
  <ng-content select="label-image-left"></ng-content>
  <span [innerHTML]="label"></span>
  <ng-content select="label-image-right"></ng-content>
</ng-template>
